<template>
  <div>
    <div class="p-4 border-b flex space-x-10">
      <img src="data:image/svg+xml;base64, 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" width="120" alt="Mobly | Sua loja de móveis e artigos de decoração">
      <div class="space-y-1">
        <h1>
          Informações da Transportadora
        </h1>
        <p class="font-normal uppercase">
          {{ completedRuler.carrier }}
        </p>
      </div>
    </div>
    <spinner v-if="loading" :loading="loading" />
    <div v-else-if="!loadingError" class="p-4">
      <div class="md:flex items-center space-y-4 md:space-x-4 md:space-y-0 text-gray-600">
        <div>
          <h1 class="text-3xl">
            Rastreio do Pedido
          </h1>
          <h2>
            Número do pedido: {{ completedRuler.order.cod }}
          </h2>
        </div>
        <div class="md:flex space-y-4 md:space-x-4 md:space-y-0 mt-2">
          <p
            v-if="!completedRuler.deliveryDate && checkIfShowInProgressData(simpleRuler)"
            class="px-2 bg-green-mobly text-white rounded-md w-max"
          >
            Pedido em andamento
          </p>
          <p
            v-if="(completedRuler.deliveryDate || completedRuler.originalDeliveryDate) && checkIfShowInProgressData(simpleRuler)"
            class="px-2 bg-green-mobly text-white rounded-md w-max"
          >
            {{ completedRuler.deliveryDate ? `Entregue em ${formatDateTime(completedRuler.deliveryDate)}` : `Entrega até ${formatDeliveryDateTime(completedRuler.originalDeliveryDate)}` }}
          </p>
        </div>
      </div>

      <div v-if="productXdWarning" class="bg-yellow-100 rounded-md w-full py-2 px-4 flex space-x-2 items-center mt-4">
        <div>
          <ExclamationCircleIcon
            class="text-yellow-500"
            size="2.2x"
          />
        </div>
        <div class="">
          <p class="font-bold">{{ productXdWarning.title }}</p>
          <p v-html="productXdWarning.description"></p>
        </div>
      </div>

      <div class="mx-auto mt-10 p-6 pb-10 xl:pb-0 bg-gray-100 xl:h-40">
        <div
          class="flex items-center flex-col xl:flex-row xl:flex-1"
        >
          <div
            v-for="(status, key) in simpleRuler"
            :key="key"
            class="items-center flex flex-col xl:flex-row -ml-40 xl:ml-0"
            :class="key === simpleRuler.length - 1 ? '' : 'xl:flex-1'"
          >
            <div
              :class="status.style.icon"
              class="relative"
            >
              <svg
                v-if="status.style.typeIcon === 'check'"
                xmlns="http://www.w3.org/2000/svg"
                class=""
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <svg
                v-if="status.style.typeIcon === 'warning'"
                class="text-white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 512"
              >
                <path
                  fill="#ffffff"
                  d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                />
              </svg>
              <div
                :class="status.style.contentText"
              >
                <div>
                  <p :class="status.style.text">{{ status.title }}</p>
                </div>
                <div class="text-gray-600 whitespace-nowrap">{{ formatDateTime(status.date) }}</div>
              </div>
            </div>
            <div 
              class="bg-gray-200 z-0 w-2 xl:w-full h-16 -my-2 xl:h-2 xl:-mx-2"
              v-if="key !== simpleRuler.length -1"
            >
              <div :class="status.style.line"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-center text-center items-center space-y-7 text-gray-600 mt-5">
        <p>
          Última atualização: {{ lastUpdate }}
        </p>
        <button
          class="p-3 bg-orange-mobly text-white rounded-md w-max font-bold focus:ring-0 focus:outline-none hover:opacity-80"
          @click="showCompleteRuler = !showCompleteRuler"
        >
          {{ showCompleteRuler ? 'Menos Informações' : 'Mais Informações' }}
        </button>
      </div>
      <div v-if="showCompleteRuler" class="transition-all duration-500">
        <div class="mx-auto mt-10 p-6 bg-gray-100">
          <div
            v-for="(status, key) in completedRuler.statuses"
            :key="key"
            class="items-center justify-center grid grid-flow-col grid-cols-6"
          >
            <div
              class="text-white items-center h-full justify-start flex flex-col col-span-1"
            >
              <div
                :class="status.style.icon"
              >
                <svg
                  v-if="status.style.typeIcon === 'check'"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <svg
                  v-if="status.style.typeIcon === 'warning'"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path d="M12.01 20H12M12 14L12.01 4" stroke="#ffffff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></path>
                  </g>
                </svg>
              </div>
              <div 
                :class="status.style.line"
                v-if="key !== completedRuler.statuses.length -1"
              >
              </div>
            </div>
            <div
              class="flex flex-col items-start font-normal text-sm col-span-5 pb-4"
            >
              <div :class="status.style.title">{{ status.title }}</div>
              <div class="text-gray-600">{{ formatDateTime(status.date) }}</div>
              <div class="text-gray-600">{{ status.details }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!loading && loadingError"
      class="flex flex-col justify-center items-center mt-40 text-gray-600 space-y-5 text-center px-5"
    >
      <h1 class="text-2xl">Erro ao buscar as informações, tente novamente.</h1>
      <button
        class="w-16 h-16 bg-orange-mobly rounded-full p-3 hover:opacity-80 focus:ring-0 focus:outline-none"
        @click="init"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            fill="#ffffff"
            d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import * as TrackingRuleRepository from '../../repositories/trackingRuler'
import * as TrackingRuleGrups from '../../enum/enum-tracking-ruler-group-cods'
import { ExclamationCircleIcon } from "@vue-hero-icons/solid"
import Spinner from '../Spinner/Spinner'

export default {
  name: 'TrackingRuler',

  data () {
    return {
      showCompleteRuler: false,
      simpleRuler: [],
      progress: 0,
      completedRuler: {},
      lastUpdate: '--',
      loading: true,
      loadingError: false,
      productXdWarning: null
    }
  },

  mounted () {
    this.init()
  },

  components: {
    Spinner,
    ExclamationCircleIcon
  },

  methods: {
    async init () {
      try {
        this.loading = true
        this.loadingError = false
        const { hash = null, key = null } = this.$route.query
        const option = key ? 'key' : 'hash'
        const value = key ? key : encodeURIComponent(hash)
        const ruler = await TrackingRuleRepository.find(option, value)
        this.simpleRuler = this.customSimpleRuler(JSON.parse(JSON.stringify(ruler.statuses)))
        this.productXdWarning = ruler.xdWarnings ? ruler.xdWarnings.sort((a,b) => new Date(b.date) - new Date(a.date))[0] : null
        this.completedRuler = this.customCompletRuler(JSON.parse(JSON.stringify(ruler)))
        if (this.productXdWarning && this.productXdWarning.newDeliveryDate) {
          this.completedRuler.originalDeliveryDate = this.productXdWarning.newDeliveryDate
        }
        this.lastUpdate = this.formatDateTime(ruler.statuses[ruler.statuses.length - 1].date)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.loadingError = true
      }
    },

    customSimpleRuler (ruler) {
      const resumedRuler = this.addMissingStatusSimpleRuler(ruler)
      const cuppedRuler = this.cupRuler(resumedRuler)
      return this.addStyleInSimpleRuler(cuppedRuler)
    },

    addMissingStatusSimpleRuler (ruler) {
      const status = ruler.map(el => ({
        title: el.groupTitle,
        groupCod: el.groupCod,
        date: el.date
      }))
      const groupedStatus = {}
      groupedStatus[TrackingRuleGrups.SHIPPED.cod] = TrackingRuleGrups.SHIPPED.title,
      groupedStatus[TrackingRuleGrups.IN_TRANSPORT.cod] = TrackingRuleGrups.IN_TRANSPORT.title,
      groupedStatus[TrackingRuleGrups.TRACKED.cod] = TrackingRuleGrups.TRACKED.title,
      groupedStatus[TrackingRuleGrups.DELIVERED.cod] = TrackingRuleGrups.DELIVERED.title
      const lastGroup = status[status.length - 1].groupCod
      const indexGroup = Object.keys(groupedStatus).indexOf(lastGroup)
      if (indexGroup === -1) return status
      const missingStatus = Object.values(groupedStatus).splice(indexGroup + 1)
      missingStatus.forEach(el => {
        status.push({
          title: el
        })
      })
      return status
    },

    cupRuler (ruler) {
      const reverseRuler = JSON.parse(JSON.stringify(ruler)).reverse()
      const STATUS_TO_CUP = [TrackingRuleGrups.INSUCESS.cod, TrackingRuleGrups.TRACKED.cod]
      const last = reverseRuler.find(el => STATUS_TO_CUP.includes(el.groupCod))
      if (!last) return ruler
      if (last.groupCod === TrackingRuleGrups.TRACKED) return this.cupByTrack(reverseRuler)
      return this.cupByInsucess(reverseRuler)
    },

    cupByInsucess (reverseRuler) {
      const STATUS_TO_CUP = {}
      STATUS_TO_CUP[TrackingRuleGrups.TRACKED.cod] = false
      STATUS_TO_CUP[TrackingRuleGrups.INSUCESS.cod] = false
      const cupeedRuler = []
      for (const rule of reverseRuler) {
        if (STATUS_TO_CUP[rule.groupCod]) continue
        if (Object.hasOwn(STATUS_TO_CUP, rule.groupCod)) STATUS_TO_CUP[rule.group] = true
        cupeedRuler.unshift(rule)
      }
      return cupeedRuler
    },

    cupByTrack (reverseRuler) {
      const STATUS_TO_CUP = {}
      STATUS_TO_CUP[TrackingRuleGrups.TRACKED.cod] = {
        count: 0,
        limit: 2
      }
      STATUS_TO_CUP[TrackingRuleGrups.INSUCESS.cod] = {
        count: 0,
        limit: 1
      }
      const cupeedRuler = []
      for (const rule of reverseRuler) {
        if (STATUS_TO_CUP[rule.groupCod]) {
          if (STATUS_TO_CUP[rule.groupCod].count === STATUS_TO_CUP[rule.groupCod].limit) continue
          STATUS_TO_CUP[rule.groupCod].count++
        }
        cupeedRuler.unshift(rule)
      }
      return cupeedRuler
    },

    addStyleInSimpleRuler (ruler) {
      const enabled = {
        line: 'bg-green-mobly rounded-full w-full h-full',
        icon: 'w-8 h-8 bg-green-mobly text-white rounded-full flex xl:justify-center font-bold p-1 z-10 relative',
        text: 'text-lg text-green-mobly font-bold capitalize',
        typeIcon: 'check'
      }
      const middle = {
        line: 'bg-green-mobly rounded-full h-1/2 w-full xl:w-1/2 xl:h-full',
        icon: 'w-8 h-8 bg-green-mobly text-white rounded-full flex xl:justify-center font-bold p-1 z-10 relative',
        text: 'text-lg text-green-mobly font-bold capitalize',
        typeIcon: 'check'
      }
      const disabled = {
        line: 'bg-green-mobly h-2 rounded-full w-0',
        icon: 'w-8 h-8 bg-gray-400 text-white rounded-full flex xl:justify-center font-bold p-1 z-10 relative',
        text: 'text-lg text-gray-400 font-bold capitalize',
        typeIcon: 'check'
      }
      const insucess = {
        line: 'bg-yellow-500 h-2 rounded-full w-full h-full',
        icon: 'w-8 h-8 bg-yellow-500 text-white rounded-full flex xl:justify-center font-bold p-1 z-10 relative',
        text: 'text-lg text-yellow-500 font-bold capitalize',
        typeIcon: 'warning'
      }
      const alingStart = {
        contentText: 'whitespace-nowrap xl:whitespace-normal xl:text-left flex flex-col items-start font-normal text-sm absolute pl-5 xl:pl-0 xl:mt-8 xl:-left-full'
      }
      const alingEnd = {
        contentText: 'whitespace-nowrap xl:whitespace-normal xl:text-right flex flex-col items-start font-normal text-sm absolute pl-5 xl:pl-0 xl:mt-8 xl:items-end xl:right-1/2'
      }
      const alineCenter = {
        contentText: 'whitespace-nowrap xl:whitespace-normal xl:text-center flex flex-col items-start font-normal text-sm absolute px-5 xl:px-0 xl:mt-8 xl:items-center'      }
      for (const [index, rule] of ruler.entries()) {
        if (index === 0) {
          rule.style = alingStart
        } else if (index === ruler.length - 1) {
          rule.style = alingEnd
        }
        else {
          rule.style = alineCenter
        }
        if (!rule.date) {
          rule.style = {
            ...rule.style,
            ...disabled
          }
          continue
        }
        const warning = rule.groupCod === TrackingRuleGrups.INSUCESS.cod
        if (warning) {
          rule.style = {
            ...rule.style,
            ...insucess
          }
          continue
        }
        if (ruler[index + 1] && !ruler[index + 1].date) {
          rule.style = {
            ...rule.style,
            ...middle
          }
          continue
        }
        rule.style = {
          ...rule.style,
          ...enabled
        }
      }
      return ruler
    },

    customCompletRuler (ruler) {
      const statuses = this.organizeStatuses(ruler.statuses)
      ruler.statuses = statuses
      return ruler
    },

    organizeStatuses (statuses) {
      const mapped = []
      const warningStyle = {
        typeIcon: 'warning',
        icon: 'flex items-center p-1 bg-yellow-500 rounded-full w-8 h-8 justify-center z-10',
        line: 'bg-yellow-500 z-0 w-1 -my-2 rounded-full h-full',
        title: 'text-lg text-yellow-500 font-bold -mb-2',
      }
      const substatusWarningStyle = {
        icon: 'flex items-center p-1 bg-yellow-500 rounded-full w-5 h-5  justify-center z-10',
        line: 'bg-yellow-500 z-0 w-1 -my-2 rounded-full h-full',
        title: 'text-lg text-gray-600 font-bold -mt-2',
        typeIcon: ''
      }
      const normalStyle = {
        typeIcon: 'check',
        icon: 'flex items-center p-1 bg-green-mobly rounded-full w-8 h-8 justify-center z-10',
        line: 'bg-green-mobly z-0 w-1 -my-2 rounded-full h-full',
        title: 'text-lg text-green-mobly font-bold -mb-2'
      }
      const substatusNormalStyle = {
        icon: 'flex items-center p-1 bg-green-mobly rounded-full w-5 h-5  justify-center z-10',
        line: 'bg-green-mobly z-0 w-1 -my-2 rounded-full h-full',
        title: 'text-lg text-gray-600 font-bold -mt-2',
        typeIcon: ''
      }
      for (const status of statuses) {
        const warning = status.groupCod === TrackingRuleGrups.INSUCESS.cod
        const subItemsRuler = status.list.map((el) => ({
          title: el.title,
          date: el.date,
          details: el.details,
            style: warning ? substatusWarningStyle : substatusNormalStyle
        }))
        mapped.push(
          {
            title: status.groupTitle,
            date: subItemsRuler[0] ? '' : status.date,
            style: warning ? warningStyle : normalStyle
          },
          ...subItemsRuler
        )
      }
      return mapped
    },

    formatDeliveryDateTime (dateTime) {
      return dateTime.substring(0, 10).split('-').reverse().join('/')
    },

    formatDateTime (dateTime, showTime = true) {
      if (!dateTime) return ''
      const dateTimeChunks = new Date(dateTime).toLocaleString('pt-BR', { hour12: false }).split(' ')
      const timeChunks = dateTimeChunks[1].split(':')
      timeChunks.splice(timeChunks.length - 1, 1)
      const date = dateTimeChunks[0].replace(',', '')
      if (!showTime) return date
      const time = timeChunks.join(':')
      const formatedDateTime = `${date} às ${time}`
      return formatedDateTime
    },

    checkIfShowInProgressData (statuses) {
      if (!statuses[0]) return false
      const lastStatus = statuses[statuses.length - 1].groupCod || null
      return lastStatus !== TrackingRuleGrups.RETURN.cod
    }
  }
}
</script>
